import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CaptainDAO } from '../../../../core/services/dao/captainDAO';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { AdminAccess } from '../../../shared/accessAdmin';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';

@Component({
  selector: 'app-captains',
  templateUrl: './captains.component.html',
  styleUrls: ['./captains.component.scss'],
})
export class CaptainsComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  public subs: Subscription[] = [];
  public columnDefs;
  public rowData;
  public editPath;
  public csv: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private captainDAO: CaptainDAO,
    private userDAO: UserDAO,
    private apiHelper: ApiHelper,
    private checkAdmin: AdminAccess,
  ) {
    const routeSub = this.route.data.subscribe((data) => {
      this.rowData = data.captains.captainResolve;
      this.columnDefs = this.createColumnDefs();
      // this.csv = this.formatCsv(this.rowData);
      this.editPath = 'manage/admin/captain/edit';
    });
    this.subs.push(routeSub);

    this.checkAdmin.checkAdminAccess(this.userDAO, this.apiHelper, this.router);
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  private createColumnDefs() {
    return [
      {
        headerName: 'Id',
        field: 'id',
        filter: 'text',
        minWidth: 30,
      },
      {
        headerName: 'Created',
        field: 'user.createdAt',
        filter: 'date',
      },
      {
        headerName: 'First Name',
        field: 'user.firstName',
        filter: 'text',
        minWidth: 100,
      },
      {
        headerName: 'Last Name',
        field: 'user.lastName',
        filter: 'text',
        minWidth: 100,
      },
      {
        headerName: 'Phone',
        field: 'user.phoneNumber',
        filter: 'text',
      },
      {
        headerName: 'Email',
        field: 'user.email',
        filter: 'text',
      },
      {
        headerName: 'City',
        field: 'city',
        filter: 'text',
      },
      {
        headerName: 'State',
        field: 'state',
        filter: 'text',
        minWidth: 70,
      },
      {
        headerName: 'License Type',
        field: 'licenseType',
        filter: 'text',
        minWidth: 50,
      },
      {
        headerName: 'Exp',
        field: 'licenseExpDate',
        filter: 'text',
        minWidth: 100,
      },
      {
        headerName: 'Status',
        field: 'status',
        filter: 'text',
        minWidth: 50,
      },
    ];
  }

  // private formatCsv(_captains) {
  //   let result, ctr, keys, columnDelimiter, lineDelimiter;
  //
  //   columnDelimiter =  ',';
  //   lineDelimiter =  '\n';
  //
  //   const captains = _captains.map((captain: Captain) => {
  //     return {
  //       captId: captain.id,
  //       created: captain.user.createdAt,
  //       status: captain.status,
  //       firstName: captain.user.firstName,
  //       lastName: captain.user.lastName,
  //       phoneNumber: captain.user.phoneNumber,
  //       email: captain.user.email,
  //       paypalHandle: captain.paypalHandle,
  //       streetAddress: captain.street,
  //       state: captain.state,
  //       zip: captain.zip,
  //       birthday: captain.user.birthday,
  //       USCGLicenseRef: captain.uscgLicenseRef,
  //       licenseType: captain.licenseType,
  //       licenseExpDate: captain.licenseExpDate,
  //       availability: captain.availability,
  //       boatTypes: captain.preferredVessels,
  //       previousExperience: captain.previousExperience,
  //       description: captain.description
  //     }
  //   });
  //
  //   keys = Object.keys(captains[0]);
  //
  //   result = '';
  //   result += keys.join(columnDelimiter);
  //   result += lineDelimiter;
  //
  //   captains.forEach(function(item) {
  //     ctr = 0;
  //     keys.forEach(function(key) {
  //       if (ctr > 0) {
  //         result += columnDelimiter;
  //       }
  //
  //       result += item[key];
  //       ctr++;
  //     });
  //     result += lineDelimiter;
  //   });
  //
  //   return result;
  // }
  //
  // public downloadCsv() {
  //   let data, filename, link;
  //   let csv = this.csv;
  //   filename = 'export.csv';
  //
  //   if (!csv.match(/^data:text\/csv/i)) {
  //     csv = 'data:text/csv;charset=utf-8,' + csv;
  //   }
  //   data = encodeURI(csv);
  //
  //   link = document.createElement('a');
  //   link.setAttribute('href', data);
  //   link.setAttribute('download', filename);
  //   link.click();
  // }
}
